import React from 'react';
import NavBrandStyles from './NavBrand.module.css';


export default function NavBrand({imagePath,link}){
    return <a className={`navbar-brand ${NavBrandStyles.NavBrand}`} href={link}>
        <img alt='brand' src={imagePath}/>
    </a>
}